module.exports = __webpack_public_path__ + "img/chengpinxiancaijidianxiandianlan.e2503049.jpg";